import { o, c as t, a as e } from "./core.0767a1be.js";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ e("path", { d: "M6 3v12" }, null, -1), r = /* @__PURE__ */ e("circle", {
  cx: "18",
  cy: "6",
  r: "3"
}, null, -1), s = /* @__PURE__ */ e("circle", {
  cx: "6",
  cy: "18",
  r: "3"
}, null, -1), l = /* @__PURE__ */ e("path", { d: "M18 9a9 9 0 0 1-9 9" }, null, -1), d = [
  n,
  r,
  s,
  l
];
function i(a, _) {
  return o(), t("svg", c, d);
}
const u = { render: i };
export {
  u as default,
  i as render
};
//# sourceMappingURL=debug.63986d15.js.map
